<template>
  <div class="ma-3 root-container">
    <div class="title">
      Payments
    </div>
    <div
      v-if="loaded"
      id="main-container"
      ref="main-container"
      layout="column"
    >
      <div id="global-header">
        <div class="gh-left">
          <div
            id="header"
            class="headline"
          >
            <v-icon
              v-if="indemnity.status == Consts.INDEMNITIES_STATUS.DRAFT"
              color="info"
              title="Waiting"
              class="mr10p"
            >
              mdi-circle-outline
            </v-icon>
            <v-icon
              v-else-if="indemnity.status == Consts.INDEMNITIES_STATUS.IN_PROGRESS"
              color="warning"
              title="Beeing treated"
              class="mr10p"
            >
              mdi-circle-outline
            </v-icon>
            <v-icon
              v-else
              color="success"
              title="Published"
              class="mr10p"
            >
              mdi-circle-outline
            </v-icon>
            <v-icon
              v-if="[Consts.APPLICATION.ALL, Consts.APPLICATION.BEESECURE].includes(indemnity.application)"
              color="black"
              class="mr10p"
              small
            >
              icon-bee48
            </v-icon>
            <v-icon
              v-if="[Consts.APPLICATION.ALL, Consts.APPLICATION.FREELANCES].includes(indemnity.application)"
              color="black"
              class="mr10p"
              small
            >
              icon-kayak48
            </v-icon>
            <strong>{{ indemnity._user_firstname }} {{ indemnity._user_lastname }}</strong>
            <span>&nbsp;from {{ formatDate(indemnity._first_session_date) }} to {{ formatDate(indemnity._last_session_date) }}</span>
            <v-icon
              v-if="indemnity._user_is_independent"
              color="black"
              class="mr10p ml10p"
              title="is independent"
            >
              mdi-meditation
            </v-icon>
            <div v-if="indemnity._user_is_independent && indemnity.invoice_number">
              ( Invoice n° {{ indemnity.invoice_number }} <v-btn
                v-if="!disableActions"
                icon
                color="primary"
                @click="editInvoiceNumber"
              >
                <v-icon>mdi-pencil</v-icon>
              </v-btn>)
            </div>
          </div>
          <div id="sub-headline">
            <div v-if="indemnity.application == Consts.APPLICATION.FREELANCES && indemnity.team">
              Équipe : <strong>{{ indemnity.team.name }}</strong>
            </div>
            <span v-if="indemnity.status == Consts.INDEMNITIES_STATUS.PUBLISHED">{{ indemnity.reference }}</span>
            <span v-if="indemnity.status == Consts.INDEMNITIES_STATUS.PUBLISHED"> - published the {{ formatDateTimeHuman(indemnity.validation_date, true) }}</span>
          </div>
          <div id="back">
            <router-link
              :to="{name: disableActions ? 'payments-trainers-index' : 'payments-payments-index'}"
              class="link-unstyled py-2 no-printable mb-3"
              style="width: max-content"
            >
              <v-icon
                color="primary"
                size="16"
              >
                mdi-arrow-left
              </v-icon>
              Back to the list
            </router-link>
          </div>
        </div>
        <div class="gh-right">
          <v-btn
            v-if="!disableActions"
            :disabled="indemnity.status != Consts.INDEMNITIES_STATUS.DRAFT"
            class="mx-0"
            icon
            title="Publish"
            @click="publish(false)"
          >
            <v-icon
              color="primary"
              size="32"
            >
              mdi-invoice-check
            </v-icon>
          </v-btn>
          <v-btn
            :disabled="indemnity.status != Consts.INDEMNITIES_STATUS.PUBLISHED || ! indemnity.doc"
            class="mx-0"
            icon
            title="Download"
            @click="download"
          >
            <v-icon
              color="primary"
              size="32"
            >
              mdi-cloud-download
            </v-icon>
          </v-btn>
          <v-btn
            v-if="!disableActions"
            :disabled="indemnity.status != Consts.INDEMNITIES_STATUS.PUBLISHED"
            class="mx-0"
            icon
            title="Unpublish"
            @click="sureUpublish = false;unpublishModal = true;"
          >
            <v-icon
              color="#FF6347"
              size="32"
            >
              mdi-publish-off
            </v-icon>
          </v-btn>
        </div>
      </div>
      <hr>
      <div id="indemnities">
        <div id="sheet">
          <header>
            <table class="no-border header">
              <tr>
                <td class="logo">
                  <img :src="`${config.AssetsUrl}/statics/snj_logo2.png`">
                  <img
                    v-if="indemnity.application == Consts.APPLICATION.BEESECURE"
                    class="bs"
                    :src="`${config.AssetsUrl}/statics/bs_logo.png`"
                  >
                </td>
                <td class="text-right">
                  <h1 v-if="indemnity.application == Consts.APPLICATION.FREELANCES">
                    Fiche d'indemnités AS (FREELANCES)
                  </h1>
                  <h1 v-else>
                    Fiche d'indemnités Trainer (BEE SECURE)
                  </h1>
                  <div class="text-right">
                    <div v-if="indemnity.reference">
                      <strong>Document n° {{ indemnity.reference }}</strong>
                    </div>
                    <div v-if="indemnity.application == Consts.APPLICATION.FREELANCES && indemnity.team">
                      Équipe : <strong>{{ indemnity.team.name }}</strong>
                    </div>
                    <div>période du {{ formatDate(indemnity._first_session_date) }} au {{ formatDate(indemnity._last_session_date) }}</div>
                  </div>
                </td>
              </tr>
            </table>
          </header>
          <section>
            <div class="user">
              <table>
                <tr><td><strong>{{ indemnity._user_firstname }} {{ indemnity._user_lastname }} (Mat. n°{{ indemnity._user_matricule }})</strong></td></tr>
                <tr>
                  <td>
                    {{ indemnity._user_streetnumber ? `${indemnity._user_streetnumber}, ` : '' }}
                    {{ indemnity._user_streetname }}<br>
                    {{ indemnity._user_country_id == 'lu' ? 'L-' : '' }}{{ indemnity._user_postalcode }} {{ indemnity._user_city }}<br>
                    {{ indemnity.country && indemnity.country.name ? indemnity.country.name.toUpperCase(): '' }}
                  </td>
                </tr>
                <tr>
                  <td>
                    <strong>Employé(e)/fonctionnaire d'État : </strong><span>{{ indemnity._user_is_state_official ? 'oui' : 'non' }}</span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <strong>IBAN : </strong><span>{{ indemnity._user_iban }}</span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <strong>BIC : </strong><span>{{ indemnity._user_bic }}</span>
                  </td>
                </tr>
              </table>
            </div>
            <div class="mt20">
              <h2>Services prestés pour le SNJ</h2>
            </div>
            <div class="main-table mt20">
              <table>
                <thead>
                  <tr>
                    <th>Session</th>
                    <th class="w350p">
                      {{ indemnity.application == Consts.APPLICATION.BEESECURE ? "Organisation" : "Centre" }}
                    </th>
                    <th class="w100p text-right">
                      Heures
                    </th>
                    <th class="w100p text-right">
                      Kms<sup>1</sup>
                    </th>
                    <th class="w100p text-right">
                      Montant
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="s in indemnity.sessions"
                    :key="s.id"
                  >
                    <td>
                      {{ getTypeFor(s.session.session_type) }}
                      <strong>#{{ s.session.reference }}</strong>
                      <span v-if="s.session.topic"> ({{ s.session.topic.name }})</span>
                      <br>
                      <em
                        class="legend"
                        v-html="buildDetails(s)"
                      />
                    </td>
                    <td v-if="indemnity.application == Consts.APPLICATION.BEESECURE">
                      {{ s.session.organization.name }}
                    </td>
                    <td v-else-if="s.session.team">
                      {{ s.session.team.center ? s.session.team.center.name : '-' }}
                    </td>
                    <td class="text-right">
                      <strong v-if="s._total_hours <= 0">-</strong>
                      <span v-else><strong>{{ numberFormat(s._total_hours) }}</strong><br>
                        <em class="legend">{{ s._unit_cost_hour != 0 ? `${s._unit_cost_hour}  €/h` : "-" }}</em></span>
                    </td>
                    <td class="text-right">
                      <strong v-if="s._total_kms <= 0">-</strong>
                      <span v-else><strong>{{ numberFormat(s._total_kms) }}</strong><br>
                        <em class="legend">{{ s._unit_cost_km != 0 ? `${s._unit_cost_km}  €/h` : "-" }}</em></span>
                    </td>
                    <td class="text-right">
                      <strong>{{ s.total_cost != 0 ? `${numberFormat(s.total_cost)}  €` : "-" }}</strong><br>
                    </td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <td
                      class="transparent"
                      colspan="2"
                    >
                      <em class="legend once-bigger"><sup>1.</sup>&nbsp;<span>Le cas échéant, le détail des frais kilométriques est fourni en annexe</span></em><br>
                      <em
                        v-if="hasTeacherRows"
                        class="legend once-bigger"
                      ><sup>2.</sup>&nbsp;<span>Les enseignants ne bénéficient pas de rémunération émanant du SNJ</span></em>
                    </td>
                    <td class="total text-right">
                      {{ numberFormat(total_hours) }}
                    </td>
                    <td class="total text-right">
                      {{ numberFormat(total_kms) }}
                    </td>
                    <td class="total text-right">
                      {{ numberFormat(total_amount) }} €
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </section>
          <section class="mt40">
            <h2>Détail des frais kilométriques</h2>
            <em
              v-if="total_kms <= 0"
              class="mt20"
            >Aucun frais kilométrique pour cette fiche d'indemnités</em>
            <div
              v-else
              class="main-table mt20"
            >
              <table class="much-spaces">
                <thead>
                  <tr>
                    <th class="w75p">
                      Session
                    </th>
                    <th class="w200p">
                      À l'intérieur de Luxembourg
                    </th>
                    <th>Parcours</th>
                    <th class="w100p text-right">
                      Kms
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="s in kilometrables"
                    :key="`kms-${s.id}`"
                  >
                    <td>#{{ s.ref }}</td>
                    <td v-if="s.has_kms">
                      {{ s.has_foreign_kms ? 'non' : 'oui' }}
                    </td>
                    <td v-else>
                      ?
                    </td>
                    <td v-if="s.has_foreign_kms">
                      <em><a @click="downloadReceipt(s.sid, s.eid, s.receipt_name)">détail accessible dans POP</a></em>
                    </td>
                    <td v-else-if="!s.has_kms">
                      <em><a @click="goToControl(s.sid)">détail accessible dans le contrôle de la session</a></em>
                    </td>
                    <td
                      v-else
                      v-html="s.steps"
                    />
                    <td class="text-right">
                      {{ numberFormat(s._total_kms) }}
                    </td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <td
                      class="transparent"
                      colspan="3"
                    />
                    <td class="total text-right">
                      {{ numberFormat(total_kms) }}
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </section>
        </div>
      </div>
    </div>
    <v-dialog
      v-model="independentsModal"
      width="750"
    >
      <v-card>
        <v-card-title class="title">
          Invoice number
        </v-card-title>
        <v-card-text>
          <p>The indemnities you're trying to publish relate to an independent. You need to enter its invoice number in order to proceed</p>
          <div>
            <v-text-field
              v-model="invoiceNumber"
              :hide-details="true"
              label="Invoice n°"
            />
          </div>
        </v-card-text>
        <v-card-actions
          layout="row"
          layout-align="end center"
        >
          <v-btn
            depressed
            color="error"
            @click="closeInvoiceModal"
          >
            Cancel
          </v-btn>
          <v-btn
            depressed
            color="success"
            @click="validateInvoiceModal"
          >
            Proceed
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="unpublishModal"
      width="750"
    >
      <v-card>
        <v-card-title class="title">
          Unpublish these indemnities
        </v-card-title>
        <v-card-text>
          <p>By unpublishing these indemnities, the sessions covered here will be released agained and will be integrated in the next indemnities record for this trainer/AS. Are you sure you want to do this ?</p>
          <div>
            <v-checkbox
              id="sure-unpublish"
              v-model="sureUnpublish"
              :hide-details="true"
              label="I have checked that these sessions did not have been already paid, and I confirm that I want to unpublish these indemnities"
            />
          </div>
        </v-card-text>
        <v-card-actions
          layout="row"
          layout-align="end center"
        >
          <v-btn
            depressed
            color="error"
            @click="sureUnpublish = false;unpublishModal = false;"
          >
            Cancel
          </v-btn>
          <v-btn
            depressed
            color="success"
            :disabled="!sureUnpublish"
            @click="unpublish"
          >
            Proceed
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
  import Consts from '@/consts'
  import Indemnities from '@/api/indemnities'
  import DatesMixin from '@/mixins/date'
  import config from '@/config'
  import axios from 'axios'

  const formater = new Intl.NumberFormat("fr-FR", {
    minimumFractionDigits: 2,  // Force au moins 2 décimales
    maximumFractionDigits: 2   // Limite à 2 décimales
  })

  export default {
    mixins: [DatesMixin],
    props: {
      id: {
        required: true
      },
      disableActions: {
        type: Boolean,
        default: () => false
      }
    },
    data() {
      return {
        indemnity: null,
        loaded: false,
        Consts,
        config,
        independentsModal: false,
        invoiceNumber: null,
        editingInvoiceNumber: false,
        unpublishModal: false,
        sureUnpublish: false
      }
    },
    computed: {
      total_kms() {
        return this.indemnity.sessions.reduce((acc, s) => acc+=parseFloat(s._total_kms), 0)
      },
      total_hours() {
        return this.indemnity.sessions.reduce((acc, s) => acc+=parseFloat(s._total_hours), 0)
      },
      total_amount() {
        return this.indemnity.sessions.reduce((acc, s) => acc+=parseFloat(s.total_cost), 0)
      },
      kilometrables() {
        return this.indemnity.sessions.filter(s => {
          const hasEvaluation = s.session.trainers_evaluations.some(te => te.user_id == this.indemnity.user_id)
          return s._total_kms > 0 && hasEvaluation
        }).map(s => {
          const evaluation = s.session.trainers_evaluations.find(te => te.user_id == this.indemnity.user_id)

          let first = true
          const steps = evaluation.steps.reduce((acc, s) => {
            if(!first) {
              acc += "<strong> > </strong>"
            }
            first = false
            acc += s.city.name

            return acc
          }, '')
          return {
            id: s.id,
            sid: s.session.id,
            ref: s.session.reference,
            has_foreign_kms: evaluation.has_foreign_kms,
            has_kms: evaluation.has_kms,
            steps,
            eid: evaluation.id,
            _total_kms: s._total_kms,
            receipt_name: evaluation.receipt ? evaluation.receipt.name : 'no-name'
          }
        })
      },
      hasTeacherRows() {
        return !! this.indemnity.sessions.find(s => {
          const ut = s.session.session_trainer.find(st => st.user_id == this.indemnity.user_id)
          return ut && ut._role == Consts.SKILL_ROLE.TEACHER
        })
      }
    },
    async mounted() {
      const {data: ind} = await Indemnities.get(this.$route.params.id, true)
      this.indemnity = ind
      this.loaded = true
    },
    methods: {
      getTypeFor(t) {
        switch(t) {
          case Consts.EVENTS:
            return "Événement "
          case Consts.ADULTS:
            return "Formation pour adultes "
          case Consts.SCHOOL:
            return "Formation scolaire "
          case Consts.TEACHERS:
            return "Formation pour enseignants "
          case Consts.YOUTH:
            return "Formation pour les jeunes "
          case Consts.OTHER:
            return "Autre activité "
          case Consts.INTERNAL:
            return "Réunion interne "
          case Consts.INTRODUCTION_DAY:
            return 'Journée d\'introduction '
          case Consts.FREELANCES_TRAINING:
            return 'Formation initiale '
          case Consts.FREELANCES_REFRESH_TRAINING:
            return 'Formation de rafraîchissement '
          case Consts.ACTIVITY:
            return 'Activité '
          case Consts.INTERNAL_AS:
            return "Réunion interne AS "
        }
      },
      buildDates(dates) {
        let formatedDates = ""
        let f = true
        dates.forEach(d => {
          if(!f) {
            formatedDates += ", "
          }
          f = false
          formatedDates += this.formatDate(d.start)
        })
        return formatedDates
      },
      getRoleForSession(s) {
        const ut = s.session.session_trainer.find(st => st.user_id == this.indemnity.user_id)

        let quality = '?'
        if(ut) {
          switch(ut._role) {
            case Consts.SKILL_ROLE.TEACHER:
              quality = "d'enseignant <sup>2</sup>"
              break
            case Consts.SKILL_ROLE.SPECIALIZED_ANIMATOR:
            case Consts.SKILL_ROLE.EXPERT:
              if(ut._as_expert) {
                quality = "d'expert"
              }
              else {
                if(s.session.session_type == Consts.FREELANCES_TRAINING || s.session.session_type == Consts.FREELANCES_REFRESH_TRAINING) {
                  quality = "de formateur"
                }
                else {
                  quality = "d'animateur spécialisé"
                }
              }

              if(this.indemnity._user_is_independent) {
                quality += ' indépendant'
              }
              break
          }
          return quality
        }
      },
      numberFormat(number) {
        return formater.format( number )
      },
      downloadReceipt (sid, eid, rname) {
        axios.get(`/sessions/${sid}/trainers-evaluations/${eid}/receipt`, {responseType: 'blob'}).then(res => {
          let blob = new Blob([res.data], {type: "octet/stream"});

          if (window.navigator && window.navigator.msSaveOrOpenBlob){
            window.navigator.msSaveBlob(blob, rname);
          }
          else
          {
            let a = document.createElement("a");
            a.style = "display: none";
            document.body.appendChild(a);
            let url = window.URL.createObjectURL(blob);
            a.href = url;
            a.download = rname
            a.click();
            window.URL.revokeObjectURL(url);
          }
        })
      },
      goToControl(sid) {
        this.$router.push({name: 'payments-controls-show', params: {id: sid}})
      },
      async publish(force = false) {
        if(! this.indemnity._user_is_independent || (force && this.invoiceNumber)) {
          const {data} = await Indemnities.publish(this.indemnity.id, {invoice_number: this.invoiceNumber})
          this.indemnity = data
          this.closeInvoiceModal()
          this.$snotify.success(`The indemnities for this user have been published with success`)
        }
        else if(!force) {
          this.invoiceNumber = null
          this.independentsModal = true
          this.editingInvoiceNumber = false //on est pas en édition on est en affectation
        }
        else {
          this.$snotify.error(`You need to fill in the invoice number before proceeding to the publication of these indemnities`)
        }
      },
      download() {
        axios.get(`/indemnities/${this.indemnity.id}/download`, {responseType: 'blob'}).then(res => {
          let blob = new Blob([res.data], {type: "octet/stream"});

          if (window.navigator && window.navigator.msSaveOrOpenBlob){
            window.navigator.msSaveBlob(blob, this.indemnity.doc.name);
          }
          else
          {
            let a = document.createElement("a");
            a.style = "display: none";
            document.body.appendChild(a);
            let url = window.URL.createObjectURL(blob);
            a.href = url;
            a.download = this.indemnity.doc.name
            a.click();
            window.URL.revokeObjectURL(url);
          }
        })
      },
      editInvoiceNumber() {
        this.editingInvoiceNumber = true
        this.independentsModal = true
        this.invoiceNumber = this.indemnity.invoice_number
      },
      closeInvoiceModal() {
        this.editingInvoiceNumber = false
        this.invoiceNumber = null
        this.independentsModal = false
      },
      async validateInvoiceModal() {
        if(!this.editingInvoiceNumber) {
          this.publish(true)
        }
        else if(this.invoiceNumber && this.invoiceNumber.trim() != ''){
          const {data} = await Indemnities.updateInvoiceNumber(this.indemnity.id, this.invoiceNumber)
          this.indemnity = data
          this.closeInvoiceModal()
          this.$snotify.success('The invoice number for these indemnities has been changed with success')
        }
      },
      async unpublish() {
        const {data} = await Indemnities.unpublish(this.indemnity.id)
        this.indemnity = data
        this.unpublishModal = false
        this.sureUnpublish = false
      },
      buildDetails(s) {
        return `${s.session.dates.length > 1 ? 'les ' : 'le '} ${this.buildDates(s.session.dates)} ${this.indemnity.application == Consts.APPLICATION.FREELANCES ? ', en qualité ' + this.getRoleForSession(s) : ''}`
      }
    }
  }
</script>
<style scoped lang="sass">
  #header
    margin-top: 10px
    display: flex
    justify-content: flex-start
    align-items: center

  .root-container
    flex-grow: 1
    align-items: stretch
    overflow: hidden
    display: flex
    flex-direction: column

  #main-container
    display: flex
    flex-direction: column
    flex-grow: 1

  .mr10p
    margin-right: 10px

  .ml10p
    margin-left: 10px

  #sub-headline
    color: #999999
    font-size: 1.2em

  #indemnities
    display: flex
    flex-direction: row
    justify-content: center

    #sheet
      width: 60%
      min-width: 700px
      padding: 4rem
      margin-top: 2rem
      background-color: white
      box-shadow: 0 10px 15px -5px rgba(0, 0, 0, 0.2)

  h1
    margin: 0px
    padding: 0px
    font-weight: bold

  .text-center
    text-align: center

  .text-right
    text-align: right

  table.header
    width: 100%
    border-collapse: collapse

    img
      max-width: 200px
      height: auto

      &.bs
        margin-left: 15px
        max-height: 53px
        width: auto

  td.logo
    width: 300px

  table.header td
    vertical-align: middle

  footer
    position: fixed
    bottom: -20px
    left: 0
    right: 0

  .user
    margin-top: 50px
    margin-bottom: 50px
    background-color: #F1F1F1
    padding: 10px
    border-radius: 9px
    width: 400px
    font-size: 1.1em

  .mt20
    margin-top: 20px

  .mt40
    margin-top: 40px

  .main-table table
    width: 100%
    border-collapse: collapse

    td
      border: 1px solid #E1E1E1
      padding: 10px 5px

    th
      border: 1px solid #E1E1E1
      padding: 5px
      background-color: #F1F1F1
      text-align: left

    td
      vertical-align: top

    th.text-right
      text-align: right !important

    td
      &.transparent
        border: none

      &.total
        font-weight: bold

    tbody > tr:hover > td
      background-color: #FEF8E7

    &.much-spaces tbody td
      padding: 10px 5px !important

    a
      text-decoration: underline

  .w50p
    width: 50px

  .w75p
    width: 75px

  .w100p
    width: 100px

  .w180p
    width: 180px

  .w200p
    width: 200px

  .w300p
    width: 300px

  .w350p
    width: 350px

  .legend
    color: #AAAAAA
    font-size: 0.9em

  .total
    background-color: #F1F1F1

  .new-page
    page-break-before: always


  #global-header
    display: flex
    flex-direction: row
    justify-content: space-between
    align-items: center

    .gh-right
      display: flex
      justify-content: flex-end
      align-items: center

</style>
